/* eslint-disable */
export default {
  onSearching: 'Cargando…',
  noContacts: 'No se encontraron registros.',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
